export default __webpack_public_path__ + "static/media/returnSVG.551219a7.svg";